import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "app__modal app__modal--loader"
}
const _hoisted_2 = { class: "container-fluid g-0 app__modalcontainer" }
const _hoisted_3 = { class: "row app__modalrow--loader" }
const _hoisted_4 = { class: "col" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loader = _resolveComponent("loader")!

  return (_ctx.LoaderParameter.isInProgress)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_loader, {
                size: 'large',
                type: 'converging-spinner'
              })
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}